module.exports = __webpack_public_path__ + "static/media/marielschaab.dba30d86.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/letterfunnel/marielschaab.webp
// module id = 237
// module chunks = 0